import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared/shared.module';
import { SubMenuComponent } from './components/sub-menu/sub-menu.component';
import { ImageTileComponent } from './components/image-tile/image-tile.component';
import { InnovateTileComponent } from './components/innovate-tile/innovate-tile.component';
import { SubMenuModalComponent } from './components/modal/sub-menu-modal/sub-menu-modal.component';
import { RecipeCardComponent } from './components/cards/recipe-card/recipe-card.component';
import { DeleteMppConfirmationModalComponent } from './components/modal/delete-mpp-confirmation-modal/delete-mpp-confirmation-modal.component';
import { SortFilterMppModalContainerComponent } from './components/modal/sort-filter-mpp-modal-container/sort-filter-mpp-modal-container.component';
import { CreateMppModalComponent } from './components/modal/create-mpp-modal/create-mpp-modal.component';
import { LockInfoPopoverComponent } from './components/lock-info-popover/lock-info-popover.component';
import { ZeroCostInfoPopoverComponent } from './components/zero-cost-info-popover/zero-cost-info-popover.component';
import { CopyRecipeCreateModalComponent } from './components/modal/copy-recipe-create-modal/copy-recipe-create-modal.component';
import { IngredientsDesktopTabletComponent } from './components/section/ingredients-container/ingredients-desktop-tablet/ingredients-desktop-tablet.component';
import { IngredientsCardComponent } from './components/cards/ingredients-card/ingredients-card.component';
import { IngredientsMobileComponent } from './components/section/ingredients-container/ingredients-mobile/ingredients-mobile.component';
import { EditPortionComponent } from './components/edit-portion/edit-portion.component';
import { AddCustomGroupModalComponent } from './components/modal/add-custom-group-modal/add-custom-group-modal.component';
import { EditRecipeDetailsModalComponent } from './components/modal/edit-recipe-details-modal/edit-recipe-details-modal.component';
import { IngredientSearchModalComponent } from './components/ingredient-search/ingredient-search-modal/ingredient-search-modal.component';
import { IngredientSearchRecipeComponent } from './components/ingredient-search/ingredient-search-recipe/ingredient-search-recipe.component';
import { IngredientSearchProductComponent } from './components/ingredient-search/ingredient-search-product/ingredient-search-product.component';
import { IngredientSearchOnListComponent } from './components/ingredient-search/ingredient-search-on-list/ingredient-search-on-list.component';
import { ViewAllLauncherComponent } from './components/ingredient-search/view-all-launcher/view-all-launcher.component';
import { UploadRecipeImageModalComponent } from './components/modal/upload-recipe-image-modal/upload-recipe-image-modal.component';
import { AcceptedFileTypesPopoverComponent } from './components/accepted-file-types-popover/accepted-file-types-popover.component';
import { IngredientDeletionModalComponent } from './components/modal/ingredient-deletion-modal/ingredient-deletion-modal.component';
import { IngredientDetailHeaderComponent } from './components/details/ingredient-detail-header/ingredient-detail-header.component';
import { IngredientDetailsComponent } from './components/details/ingredient-details/ingredient-details.component';
import { IngredientDetailSubHeaderComponent } from './components/details/ingredient-detail-sub-header/ingredient-detail-sub-header.component';
import { IngredientUnitsOfMeasureComponent } from './components/details/ingredient-units-of-measure/ingredient-units-of-measure.component';
import { IngredientUomInfoPopoverComponent } from './components/details/ingredient-uom-info-popover/ingredient-uom-info-popover.component';
import { LimitToTwoNumericPipe } from '@shared/pipes/limit-to-two-numeric.pipe';
import { IngredientDetailTouchModalComponent } from './components/details/ingredient-detail-touch-modal/ingredient-detail-touch-modal.component';
import { IngredientDetailTouchHeaderComponent } from './components/details/ingredient-detail-touch-header/ingredient-detail-touch-header.component';
import { IngredientDetailTouchValuesComponent } from './components/details/ingredient-detail-touch-values/ingredient-detail-touch-values.component';
import { IngredientDetailTouchActionsComponent } from './components/details/ingredient-detail-touch-actions/ingredient-detail-touch-actions.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, SharedModule],
  declarations: [
    SubMenuComponent,
    ImageTileComponent,
    InnovateTileComponent,
    SubMenuModalComponent,
    RecipeCardComponent,
    DeleteMppConfirmationModalComponent,
    SortFilterMppModalContainerComponent,
    CreateMppModalComponent,
    LockInfoPopoverComponent,
    ZeroCostInfoPopoverComponent,
    AcceptedFileTypesPopoverComponent,
    CopyRecipeCreateModalComponent,
    IngredientsDesktopTabletComponent,
    IngredientsMobileComponent,
    IngredientsCardComponent,
    EditPortionComponent,
    AddCustomGroupModalComponent,
    EditRecipeDetailsModalComponent,
    IngredientSearchModalComponent,
    IngredientSearchRecipeComponent,
    IngredientSearchProductComponent,
    IngredientSearchOnListComponent,
    ViewAllLauncherComponent,
    UploadRecipeImageModalComponent,
    IngredientDeletionModalComponent,
    IngredientDetailHeaderComponent,
    IngredientDetailsComponent,
    IngredientDetailSubHeaderComponent,
    IngredientUnitsOfMeasureComponent,
    IngredientUomInfoPopoverComponent,
    IngredientDetailTouchModalComponent,
    IngredientDetailTouchHeaderComponent,
    IngredientDetailTouchValuesComponent,
    IngredientDetailTouchActionsComponent,
  ],
  exports: [
    SubMenuComponent,
    ImageTileComponent,
    InnovateTileComponent,
    SubMenuModalComponent,
    RecipeCardComponent,
    DeleteMppConfirmationModalComponent,
    SortFilterMppModalContainerComponent,
    CreateMppModalComponent,
    LockInfoPopoverComponent,
    ZeroCostInfoPopoverComponent,
    AcceptedFileTypesPopoverComponent,
    CopyRecipeCreateModalComponent,
    IngredientsDesktopTabletComponent,
    IngredientsMobileComponent,
    IngredientsCardComponent,
    EditPortionComponent,
    AddCustomGroupModalComponent,
    EditRecipeDetailsModalComponent,
    IngredientSearchModalComponent,
    IngredientSearchRecipeComponent,
    IngredientSearchProductComponent,
    IngredientSearchOnListComponent,
    ViewAllLauncherComponent,
    UploadRecipeImageModalComponent,
    IngredientDeletionModalComponent,
    IngredientDetailHeaderComponent,
    IngredientDetailsComponent,
    IngredientDetailSubHeaderComponent,
    IngredientUnitsOfMeasureComponent,
    IngredientUomInfoPopoverComponent,
    IngredientDetailTouchModalComponent,
    IngredientDetailTouchHeaderComponent,
    IngredientDetailTouchValuesComponent,
    IngredientDetailTouchActionsComponent,
  ],
  providers: [LimitToTwoNumericPipe],
})
export class MppShareModule {}
